/** @format */

import React, { Component } from "react";
import {
  Container,
  Row,
  Col,
  Breadcrumb,
  BreadcrumbItem,
  Collapse,
  FormGroup,
  Label,
  Input,
  Form,
  Button,
  CustomInput,
} from "reactstrap";
import Header from "../components/Header";
import Footer from "../components/Footer";
import CustomerSidebar from "../components/CustomerSidebar";
import {
  setCookie,
  getCookie,
  eraseCookie,
  setLocalStorage,
  getLocalStorage,
  getUrlParam,
} from "../global/browserFunctions";
import Select from "react-select";
import usStates from "../data/us-states";
import caStates from "../data/ca-states";
import ReactPhoneInput from "react-phone-input-2";
import { showNotification } from "../global/notification";
import jquery from "jquery";
import Loader from "../components/Loader";
import { addressUrl } from "../global/url";

class UpdateAddress extends Component {
  constructor(props) {
    super(props);
    this.state = {
      title: "Add Address",
      isEdit: false,
      EditAddressID: "",
      formInputs: {},
      loading: false,
      selectState: usStates,
      selectCountry: [
        { label: "United States", value: "US" },
        { label: "Canada", value: "CA" },
      ],
      addrphone: "",
      defaultshipping: false,
      defaultbilling: false,
    };
    this.state.countryid = this.state.selectCountry[0];
    this.state.state = this.state.selectState[0];
    this.customSelectStyles = {
      control: (provided, state) => ({
        ...provided,
        border: "1px solid #ced4da",
        borderRadius: "0",
        width: "auto",
        cursor: "pointer",
      }),
      indicatorSeparator: (provided, state) => ({
        display: "none",
      }),
      menu: (provided, state) => ({
        ...provided,
        color: "#343a40",
        border: "0 solid #fff",
        borderRadius: 0,
        boxShadow: "0 0 1.2rem rgba(0, 0, 0, .15)",
      }),
      option: (provided, { data, isDisabled, isFocused, isSelected }) => ({
        ...provided,
        backgroundColor: isDisabled
          ? null
          : isSelected
            ? "#bcac76"
            : isFocused
              ? "#eee"
              : null,
        ":active": {
          ...provided[":active"],
          backgroundColor: "#e2dabc",
        },
        cursor: "pointer",
      }),
    };
    this.handleChange = this.handleChange.bind(this);
    this.handleSelect = this.handleSelect.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    document.title = this.state.title;

    if (!getCookie("log")) {
      this.GoToPage("/");
    }
  }

  componentDidMount() {
    var isEdit = getUrlParam("id") ? true : false;
    if (isEdit) {
      this.setState({ title: "Edit Address" });
      this.setState({ isEdit: isEdit });
      document.title = "Edit Address";

      this.fetchAddress();
    }
  }

  GoToPage(path) {
    this.props.history.push(path);
  }

  fetchAddress() {
    this.setState({ loading: true });
    var addressArr = getLocalStorage("Address");
    if (addressArr) {
      addressArr = JSON.parse(addressArr);
      this.setAddressFields(addressArr);
    } else {
      var query = "&method=view&customer=";
      var customer = getCookie("customid");
      query += customer;
      var self = this;
      jquery
        .ajax({
          url: addressUrl + query,
          Cache: false,
          dataType: "jsonp",
        })
        .done(function (data) {
          self.setState({ loading: false });
          try {
            data = JSON.parse(data);
            if (data[0].responseString == "SUCCESS") {
              var address = JSON.parse(
                decodeURIComponent(data[0].responseMessage)
              );
              setLocalStorage("Address", JSON.stringify(address));
              self.setAddressFields(address);
            } else {
              showNotification(
                "Sorry",
                "danger",
                "An unknown error occurred. Couldn't fetch your addresses"
              );
            }
          } catch (error) {
            console.log("error@address", error);
            showNotification(
              "Sorry",
              "danger",
              "An unknown error occurred. Couldn't fetch your addresses"
            );
          }
        });
    }
  }

  setAddressFields(addrsArr) {
    this.setState({ loading: false });
    var id = getUrlParam("id");
    if (id) {
      var index = addrsArr.findIndex((x) => x.addressinternalid.value == id);
      var address = addrsArr[index];
      if (address) {
        this.setState({ EditAddressID: id });
        this.setState({ addressee: address.addressee.value });
        this.setState({ addr1: address.address1.value });
        this.setState({ addr2: address.address2.value });
        this.setState({ city: address.city.value });
        this.setState({ zip: address.zipcode.value });
        this.setState({ addrphone: address.addressphone.value });
        this.setState({ defaultbilling: address.isdefaultbilling.value });
        this.setState({ defaultshipping: address.isdefaultshipping.value });

        this.setCountryState(address);
      } else {
        showNotification(
          "Sorry",
          "info",
          "Couldn't find an address with the given ID"
        );
      }
    } else {
      showNotification(
        "Sorry",
        "info",
        "Couldn't find an address with the given ID"
      );
    }
  }

  setCountryState(address) {
    if (address.country.value == "US") {
      this.setState({ countryid: this.state.selectCountry[0] }, function () {
        var state = address.state.value;
        var index = usStates.findIndex((x) => x.value == state);
        if (index) {
          this.setState({ state: usStates[index] });
          this.setState({ selectState: usStates });
        }
      });
    } else {
      this.setState({ countryid: this.state.selectCountry[1] }, function () {
        var state = address.state.value;
        var index = caStates.findIndex((x) => x.value == state);
        if (index) {
          this.setState({ state: caStates[index] });
          this.setState({ selectState: caStates });
        }
      });
    }
  }

  handleChange(e, name) {
    if (name == "addrphone") {
      this.setState({ addrphone: e });
    } else {
      var name = e.target.name;
      if (name == "defaultshipping" || name == "defaultbilling")
        var value = e.target.checked;
      else var value = e.target.value;
      this.setState({ [name]: value });
    }
  }

  checkForParameter(parameter) {
    if (
      parameter != "" &&
      parameter !== null &&
      parameter !== undefined &&
      parameter !== false &&
      parameter !== "null" &&
      parameter !== "undefined" &&
      parameter !== "false" &&
      parameter != " "
    )
      return parameter;
    else {
      return "";
    }
  }

  handleSelect(e, t) {
    var self = this;
    this.setState({ [t.name]: e });
    if (t.name == "countryid") {
      if (e.value == "CA") {
        this.setState({ selectState: caStates });
        this.setState({ state: caStates[0] });
      } else {
        this.setState({ selectState: usStates });
        this.setState({ state: usStates[0] });
      }
    }
  }

  handleSubmit(e) {
    e.preventDefault();
    if (this.state.isEdit) {
      var query = "&method=update&customer=";
      var customer = getCookie("customid");
      query += customer;
      query += "&addressid=" + this.state.EditAddressID;
    } else {
      var query = "&method=add&customer=";
      var customer = getCookie("customid");
      query += customer;
    }
    var phone = this.isValidPhone(this.state.addrphone);
    if (phone) {
      var addressUrl =
        "&addressee=" +
        encodeURIComponent(this.checkForParameter(this.state.addressee)) +
        "&addr1=" +
        encodeURIComponent(this.state.addr1) +
        "&addr2=" +
        encodeURIComponent(this.checkForParameter(this.state.addr2)) +
        "&city=" +
        encodeURIComponent(this.state.city) +
        "&state=" +
        encodeURIComponent(this.state.state.value) +
        "&zip=" +
        encodeURIComponent(this.state.zip) +
        "&countryid=" +
        encodeURIComponent(this.state.countryid.value) +
        "&addrphone=" +
        encodeURIComponent(phone) +
        "&defaultbilling=" +
        encodeURIComponent(this.state.defaultbilling) +
        "&defaultshipping=" +
        encodeURIComponent(this.state.defaultshipping);

      query += addressUrl;
      this.setAddress(query);
    }
  }

  setAddress(query) {
    var self = this;
    self.setState({ loading: true });
    jquery
      .ajax({
        url: addressUrl + query,
        Cache: false,
        dataType: "jsonp",
      })
      .done(function (data) {
        self.setState({ loading: false });
        try {
          data = JSON.parse(data);
          console.log("data", data);
          if (data[0].responseString == "SUCCESS") {
            showNotification("Done!", "success", "Address saved");
            setTimeout(
              //Timeout is set for user to read success message before redirecting to address page
              function () {
                self.GoToPage("/address");
              }.bind(this),
              1800
            );
          } else {
            showNotification("Sorry", "danger", "An unknown error occurred.");
          }
        } catch (error) {
          console.log("error@address", error);
          showNotification("Sorry", "danger", "An unknown error occurred.");
        }
      })
      .fail(function () {
        self.setState({ loading: false });
        showNotification(
          "Sorry",
          "danger",
          "An unknown error occurred. Check you network"
        );
      });
  }

  isValidPhone(phone) {

    if (phone.length < 8) {
      showNotification(
        "Invaild Phone",
        "info",
        "Kindly enter a valid phone number"
      );
      return false;
    } else {
      if (phone.indexOf('+') >= 0) {
        return phone;
      }
      else {
        return "+" + phone;
      }

    }
  }

  render() {
    return (
      <React.Fragment>
        <Loader loading={this.state.loading} />
        <Header headermenu={this.headermenu} history={this.props.history} />
        <section className="hero py-6">
          <Container>
            <Breadcrumb className="pl-0">
              <BreadcrumbItem>
                <a href="/home">Home</a>
              </BreadcrumbItem>
              <BreadcrumbItem active>{this.state.title}</BreadcrumbItem>
            </Breadcrumb>
            <div className="hero-content">
              <h1 className="hero-heading">{this.state.title}</h1>
            </div>
          </Container>
        </section>
        <section className="pb-6">
          <Container>
            <Row>
              <Col xl="3" lg="4" className="mb-5">
                <CustomerSidebar history={this.props.history} />
              </Col>
              <Col lg="8" xl="9">
                <Col lg="8" xl="9" className="mb-5 mb-lg-0">
                  <Form onSubmit={this.handleSubmit}>
                    <Row>
                      <FormGroup className="col-md-12">
                        <Label className="form-label" for="addressee">
                          Addressee
                        </Label>
                        <Input
                          type="text"
                          name="addressee"
                          placeholder="Addressee"
                          id="addressee"
                          value={this.state.addressee || ""}
                          onChange={(e) => this.handleChange(e)}
                        />
                      </FormGroup>
                      <FormGroup className="col-md-12">
                        <Label className="form-label" for="addr1">
                          Address line 1
                        </Label>
                        <Input
                          type="text"
                          name="addr1"
                          placeholder="1234 Main Street"
                          id="addr1"
                          value={this.state.addr1 || ""}
                          onChange={(e) => this.handleChange(e)}
                          required
                        />
                      </FormGroup>

                      <FormGroup className="col-md-12">
                        <Label className="form-label" for="addr2">
                          Address line 2
                        </Label>
                        <Input
                          type="text"
                          name="addr2"
                          placeholder="Apt. 3 or Suite #1516"
                          id="addr2"
                          value={this.state.addr2 || ""}
                          onChange={(e) => this.handleChange(e)}
                        />
                      </FormGroup>
                      <FormGroup className="col-md-6">
                        <Label className="form-label" for="city">
                          City
                        </Label>
                        <Input
                          type="text"
                          name="city"
                          placeholder="City"
                          id="city"
                          required
                          value={this.state.city || ""}
                          onChange={(e) => this.handleChange(e)}
                        />
                      </FormGroup>
                      <FormGroup className="col-md-6">
                        <Label className="form-label" for="zip">
                          ZIP
                        </Label>
                        <Input
                          type="text"
                          name="zip"
                          placeholder="ZIP"
                          id="zip"
                          required
                          pattern="^\d{5}(?:[-\s]\d{4})?$"
                          value={this.state.zip || ""}
                          onChange={(e) => this.handleChange(e)}
                        />
                      </FormGroup>
                      <Col md="6">
                        <h6 className="detail-option-heading">Country</h6>
                        <Select
                          name="countryid"
                          id="countryid"
                          options={this.state.selectCountry}
                          autosize={true}
                          defaultValue={this.state.selectCountry[0]}
                          className="react-select-container"
                          classNamePrefix="react-select"
                          onChange={(e, t) => this.handleSelect(e, t)}
                          styles={this.customSelectStyles}
                          isSearchable={false}
                          value={this.state.countryid}
                        />
                      </Col>
                      <Col md="6">
                        <h6 className="detail-option-heading">State</h6>
                        <Select
                          name="state"
                          id="state"
                          options={this.state.selectState}
                          autosize={true}
                          defaultValue={this.state.selectState[0]}
                          className="react-select-container"
                          classNamePrefix="react-select"
                          onChange={(e, t) => this.handleSelect(e, t)}
                          styles={this.customSelectStyles}
                          isSearchable={false}
                          value={this.state.state}
                        />
                      </Col>
                      <FormGroup className="col-md-12">
                        <Label
                          className="form-label addrs-phone"
                          for="addrphone"
                        >
                          Phone
                        </Label>
                        <ReactPhoneInput
                          inputExtraProps={{
                            name: "addrphone",
                            required: true,
                            autoFocus: true,
                          }}
                          country={"us"}
                          name="addrphone"
                          required
                          id="addrphone"
                          value={this.state.addrphone}
                          onChange={(addrphone) =>
                            this.handleChange(addrphone, "addrphone")
                          }
                        />
                      </FormGroup>
                      <FormGroup className="col-md-6">
                        <CustomInput
                          type="checkbox"
                          name="defaultbilling"
                          data-content="Is default billing?"
                          id="defaultbilling"
                          label={
                            <React.Fragment>Is Default Billing?</React.Fragment>
                          }
                          checked={this.state.defaultbilling}
                          onChange={(e) => this.handleChange(e)}
                        />
                      </FormGroup>
                      <FormGroup className="col-md-6">
                        <CustomInput
                          type="checkbox"
                          name="defaultshipping"
                          data-content="Is default shipping?"
                          id="defaultshipping"
                          label={
                            <React.Fragment>
                              Is Default Shipping?
                            </React.Fragment>
                          }
                          checked={this.state.defaultshipping}
                          onChange={(e) => this.handleChange(e)}
                        />
                      </FormGroup>
                    </Row>
                    <FormGroup className="mt-4">
                      <Button color="dark" type="submit">
                        <i className={`far fa-save mr-2`} />
                        Save
                      </Button>
                    </FormGroup>
                  </Form>
                </Col>
              </Col>
            </Row>
          </Container>
        </section>
        <Footer />
      </React.Fragment>
    );
  }
}

export default UpdateAddress;
